import { recursiveCamelCaseCipher } from "@src/global_functions/postgrestApi";
import { useQuery as useReactQuery } from "@tanstack/react-query";
import { CamelCasedPropertiesDeep } from "type-fest";
import FetchClients, { ClientOutput } from "../client";

type StructureUseTypesResponseSnakeCase =
  ClientOutput["tenantsAndSpaces"]["StructureUseTypesResponse"];
type StructureUseTypesResponse =
  CamelCasedPropertiesDeep<StructureUseTypesResponseSnakeCase>;

const structureUseTypes = {
  useQuery,
} as const;

export default structureUseTypes;

const STRUCTURE_USE_TYPES_QUERY_KEY = "/structure-use-types";

const getStructureUseTypes = async () => {
  const { data, error } = await FetchClients.tenantsAndSpaces.GET(
    "/structure-use-types",
    {}
  );

  if (data) return recursiveCamelCaseCipher(data) as StructureUseTypesResponse;
  throw new Error(error);
};

function useQuery() {
  return useReactQuery({
    queryKey: [STRUCTURE_USE_TYPES_QUERY_KEY],
    queryFn: () => getStructureUseTypes(),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
